<div class="email-header-attachments">
  <span class="email-attachment" *ngFor="let attachment of attachments" title='{{ attachment.name }}'>
    <i class="email-attachment-icon fa {{ getIconClass(attachment.contentType) }}" [attr.data-automation-id]="'gc-email-attachment-icon'"></i>
    <a class="email-attachment-label"
       target="_blank"
       [href]="attachment.contentUri"
       [attr.data-automation-id]="'gc-email-attachment-label'">
      {{ attachment.name }}
    </a>
    <a class="email-attachment-control"
       *ngIf="isEditable"
       (click)="delete(attachment)"
       [attr.data-automation-id]="'gc-email-attachment-control'">
      <i class="icon fa fa-times-circle"></i>
    </a>
  </span>
</div>
